import { useCallback, useState } from 'react';

import type { SubmitError } from './types';
import { ErrorResponses } from './errorResponses';

export function useTransformError() {
  const [error, setError] = useState<SubmitError>();

  const transformError = useCallback((amplifyError: unknown) => {
    /**
     * Accounts for errors that either hanve the shape of AmplifyError
     * but missing a known code  value
     *
     * or
     *
     * errors that do not match the shape of AmplifyError
     */
    setError(ErrorResponses.Unknown);
    return;
  }, []);

  return {
    error,
    transformError,
  };
}
